import { categories, HD_HOST_NAME } from '../utils';

const {
  FENCE, SOLAR, SHOWER_DOOR,
  KITCHEN_CABINET, CABINET_MAKEOVER,
  CLOSET, GARAGE_ORG, WINDOW,
  KIRSCH_WINDOWS, WATER_TREATMENT,
  BATHLINERS
} = categories;

const costGuideURLsMap = new Map([
  [FENCE, '/c/cost_install_fence'],
  [SOLAR, '/c/cost_install_solar_panels'],
  [SHOWER_DOOR, '/c/cost_bathroom_remodel '],
  [KITCHEN_CABINET, '/c/cost_cabinet_installation'],
  [CABINET_MAKEOVER, '/c/cost_cabinet_refacing'],
  [CLOSET, '/c/cost_install_custom_closet'],
  [GARAGE_ORG, '/c/cost_install_custom_closet'],
  [WINDOW, '/c/cost_install_replacement_windows'],
  [KIRSCH_WINDOWS, '/c/cost_install_blinds'],
  [WATER_TREATMENT, '/c/cost_install_water_treatment_system'],
  [BATHLINERS, '/c/cost_walk_in_tub_installation']
]);

export const getCostGuideURL = (category) => (
  costGuideURLsMap.get(category)
  && HD_HOST_NAME + costGuideURLsMap.get(category)
);
